export const apiKey = Object.freeze({
  GOOGLE_MAPS_API_KEY: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
  BANKCODE_API_KEY: import.meta.env.VITE_BANKCODE_API_KEY,
});
